<template>
  <zone-wrapper
    v-if="fields.scriptUrl?.value"
    :api-settings="bookTableAPISettings"
    :script-url="fields.scriptUrl.value"
    window-key="table-booking-settings-47C61"
  >
    <div id="table-booking-widget-47C61" class="book-table-widget">
      <noscript>The Booking App requires JavaScript to be enabled.</noscript>
    </div>
  </zone-wrapper>
</template>

<script setup>
import ZoneWrapper from '../ZoneWrapper/ZoneWrapper.vue';
import { useJssStore } from '../../../stores/jssStore';

const props = defineProps({
  fields: {
    type: Object,
    default: () => ({}),
  },
  rendering: {
    type: Object,
  },
  params: {
    type: Object,
    default: () => ({}),
  },
});

const jssStore = useJssStore();

const bookTableAPISettings = {
  env: props.fields.env?.value,
  apiUrl: props.fields.scriptApiUrl?.value,
  bookingGTMId: props.fields.bookingGtmId?.value,
  bookingGTMAuth: props.fields.bookingGtmAuth?.value,
  bookingGTMEnv: props.fields.bookingGtmEnv?.value,
  softOpt: props.fields.bookingSoftOpt?.value,
  venueId: jssStore.venueId?.toString().padStart(4, '0'),
  brand: jssStore.brandName,
  venueName: jssStore.venueName,
  venueImage: props.fields.venueImage?.value?.src ?? '',
  segment: jssStore.segment,
  worldpayHelper:
    window?.location.protocol + '//' + window?.location.host + props.fields.worldpayPath?.value,
};
</script>

<style lang="scss">
@import './scss/BookTableWidget.scss';
</style>
